import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { abilityGuard } from './core/ability.guard';
import { buildPageRoutes } from './core/page-registry';
import { APP_PAGES } from './pages';

export const routes: Routes = [
  {
    path: 'callback',
    children: [],
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/layout').then((m) => m.LayoutComponent),
    children: [
      ...buildPageRoutes(APP_PAGES).map((route) => ({
        ...route,
        canActivate: [abilityGuard],
      })),
      {
        path: '',
        loadComponent: () => import('./welcome/welcome').then((m) => m.WelcomeComponent),
        pathMatch: 'full' as const,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
